import { useQuery } from '@tanstack/react-query';

import { getBrandStrategy } from '../services';
import { useBrandStrategyStore } from '../store/brand-strategy-store';
import { createStableQueryOptions } from '../utils/query-options';

export const useBrandStrategy = (projectId: string) => {
  const { setBrandStrategy, setBrandStrategyId } = useBrandStrategyStore();

  return useQuery({
    queryKey: ['brandStrategy', projectId],
    queryFn: async () => {
      try {
        const response = await getBrandStrategy(projectId);
        const brandStrategy = response.data;

        if (brandStrategy) {
          setBrandStrategyId(brandStrategy.id);
          setBrandStrategy(brandStrategy);
        }

        return brandStrategy;
      } catch (error) {
        console.error('Failed to fetch brand strategy');
        throw error;
      }
    },
    enabled: !!projectId,
  });
};

export const useGetValueProposition = (projectId: string) => {
  const fields =
    'products,why_customers_choose_you,why_customers_do_not_choose_you,competitors';
  return useQuery({
    queryKey: ['value-proposition', projectId],
    queryFn: () => getBrandStrategy(projectId, fields),
    ...createStableQueryOptions(),
  });
};

export const useGetToneOfVoice = (projectId: string) => {
  const fields = 'tone_of_voices';
  return useQuery({
    queryKey: ['tone-of-voice', projectId],
    queryFn: () => getBrandStrategy(projectId, fields),
    ...createStableQueryOptions(),
  });
};

export const useGetContentPlan = (projectId: string) => {
  const fields = 'objectives,pillars';
  return useQuery({
    queryKey: ['content-plan', projectId],
    queryFn: () => getBrandStrategy(projectId, fields),
    ...createStableQueryOptions(),
  });
};
